import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import client from '@/lib/api';
import { useToast } from '@/hooks/use-toast';
import { Loader2 } from 'lucide-react';

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast({ title: 'Password too short', description: 'Use at least 6 characters.' });
      return;
    }
    if (password !== confirm) {
      toast({ title: "Passwords don't match" });
      return;
    }
    setLoading(true);
    try {
      await client.post('/auth/reset-password', { token, new_password: password });
      toast({ title: 'Password updated', description: 'You can now log in with your new password.' });
      navigate('/login');
    } catch (err) {
      toast({ title: 'Could not reset password', description: err?.response?.data?.detail || 'The link may have expired.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-[80vh] flex items-center">
      <div className="absolute inset-0 viso-grid opacity-30" />
      <div className="relative w-full max-w-md mx-auto px-6">
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-8">
          <div className="text-xs font-mono uppercase tracking-widest text-cyan-300 mb-3">Reset password</div>
          <h1 className="font-display text-3xl font-bold">Choose a new password</h1>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="text-slate-300">New password</Label>
              <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="bg-black/30 border-white/10 mt-1" />
            </div>
            <div>
              <Label className="text-slate-300">Confirm new password</Label>
              <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="bg-black/30 border-white/10 mt-1" />
            </div>
            <Button disabled={loading} className="w-full bg-cyan-400 hover:bg-cyan-300 text-slate-900 font-medium">
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Update password
            </Button>
          </form>
          <div className="mt-6 text-sm text-slate-400">
            <Link to="/login" className="hover:text-cyan-300">Back to log in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
